import { EProjectSection, trackEventV2 } from '../trackEventV2';
import { EOwnerProfileEventName, IOwnerProfileEvent } from './types';

export function trackOwnerProfileViewed(event: IOwnerProfileEvent) {
  trackEventV2(EOwnerProfileEventName.PROFILE_VIEWED, EProjectSection.MARKETPLACE, {
    ...event,
  });
}
